import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f9445574"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "抽卡规则", -1));
const _hoisted_2 = {
  class: "content render-hide-scroll"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showRules,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $options.showRules = $event),
    "close-on-click-overlay": false,
    class: "popup-box-rules"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = $event => $options.showRules = false)
    }), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rules_arr, (item, index) => {
      return _openBlock(), _createElementBlock("li", {
        key: index,
        class: "item"
      }, _toDisplayString(item.content), 1);
    }), 128))])])]),
    _: 1
  }, 8, ["show"]);
}